import React from "react"
import { Tooltip, IconButton } from "@material-ui/core";
import classNames from "classnames";
import dashboard from "../../../images/sidebar_icon/dashboard.png";
import users from "../../../images/sidebar_icon/user.png";
import search from "../../../images/sidebar_icon/search.png";
import requirement from "../../../images/sidebar_icon/requirement.png";
import invoice from "../../../images/sidebar_icon/invoice.png";

import useStyles from "../styles";
import SidebarLink from "../components/SidebarLink/SidebarLink";

const FreelancerSidebar = ({ location, isSidebarOpened }) => {
    const classes = useStyles();
    const freelancerItems = [
        {
            id: 0,
            label: "Live Status",
            link: "/app/dashboard",
            view: true,
            icon: (
                <Tooltip title="Live Status" placement="right">
                    <IconButton>
                        <img
                            src={dashboard}
                            alt="dashboard"
                            className={classNames(classes.Icon1)}
                        />
                    </IconButton>
                </Tooltip>
            ),
        },
        {
            id: 1,
            label: "Requirements",
            link: "/app/freelancer_requirements",
            view: true,
            icon: (
                <Tooltip title="Requirements" placement="right">
                    <IconButton>
                        <img
                            src={requirement}
                            alt="requirement"
                            className={classNames(classes.Icon2)}
                        />
                    </IconButton>
                </Tooltip>
            ),
        },
        {
            id: 2,
            label: "Candidates",
            link: "/app/freelancer_candidates",
            view: true,
            icon: (
                <Tooltip title="Candidates" placement="right">
                    <IconButton>
                        <img
                            src={users}
                            alt="candidates"
                            className={classNames(classes.Icon3)}
                        />
                    </IconButton>
                </Tooltip>
            ),
        },
        {
            id: 3,
            label: "Search Candidates",
            link: "/app/search",
            view: true,
            icon: (
                <Tooltip title="Search Candidates" placement="right">
                    <IconButton>
                        <img
                            src={search}
                            alt="candidates"
                            className={classNames(classes.Icon4)}
                        />
                    </IconButton>
                </Tooltip>
            ),
        },
        // {
        //     id: 4,
        //     label: "Invoice",
        //     link: "/app/redeem_invoice",
        //     view: true,
        //     icon: (
        //         <Tooltip title="Invoice" placement="right">
        //             <IconButton>
        //                 <img
        //                     src={invoice}
        //                     alt="Invoice"
        //                     className={classNames(classes.Icon4)}
        //                 />
        //             </IconButton>
        //         </Tooltip>
        //     ),
        // },
    ];
    return (
        <>
            {
                freelancerItems.map((link) => (
                    <SidebarLink
                        key={link.id}
                        location={location}
                        isSidebarOpened={isSidebarOpened}
                        {...link}
                    />
                ))
            }
        </>
    );
}


export default FreelancerSidebar;